/**
 * Display Object
 *
 * @package Wordpress\sww
 * @since 20191104
 * @version 1.0.0
 */

jQuery( function($) {

	//add menuDisplay object
	swwapp.Display = {

		/**
		 * Get all menu-items in screen-menu
		 *
		 * @since	20191104
		 * @var		array	menuItems	Array with all screen-menu items
		 */
		menuItems: $( '#sww-screen-menu-default' ).children( 'li' ),

		/**
		 * Get all menu-items in sticky-screen-menu
		 *
		 * @since	20191104
		 * @var array menuItemsSticky	Array with all screen-menu items
		 */
		menuItemsSticky: $( '#sww-sticky-screen-menu-default' ).children( 'li' )
	};

	/**
	 * Sign out the menu items in screen- and sticky-screen-menu
	 *
	 * @since	20191104
	 * @var		boolean	isuneqal	Default=false. Change to true if count of menu-items is unequal
	 * @var		counter	integer	The result of menu-items divided by 2 rounded down
	 * @return	void
	 */
	swwapp.Display.signItems = function() {
			var isunequal = false;
			var counter = Math.floor( swwapp.Display.menuItems.length / 2 );

			//if count of items is unequal
			if( swwapp.Display.menuItems.length % 2 != 0  ) {
				isunequal = true;
			}

			//set the display-classes
			for( i = 0; i < swwapp.Display.menuItems.length; i++ ) {
				if( i <= ( counter - 1 ) ) {
					$( swwapp.Display.menuItems[ i ] ).find( 'ul.sub-menu' ).addClass( 'menuDisplay-left' );
					$( swwapp.Display.menuItemsSticky[ i ] ).find( 'ul.sub-menu' ).addClass( 'menuDisplay-left' );
				} else if( i === ( counter ) && isunequal === true ) {
					$( swwapp.Display.menuItems[ i ] ).find( 'ul.sub-menu' ).addClass( 'menuDisplay-center' );
					$( swwapp.Display.menuItemsSticky[ i ] ).find( 'ul.sub-menu' ).addClass( 'menuDisplay-center' );
				} else if( i > ( counter - 1 ) ) {
					$( swwapp.Display.menuItems[ i ] ).find( 'ul.sub-menu' ).addClass( 'menuDisplay-right' );
					$( swwapp.Display.menuItemsSticky[ i ] ).find( 'ul.sub-menu' ).addClass( 'menuDisplay-right' );
				}
			}

			return;
	};

	//trigger, when DOM is loaded
	$( document ).ready( function() {

		//triggers, when imgages are loaded (Firefox)
		$( window ).on( 'load', swwapp.Display.signItems );

	} );

	//trigger on window change
	$( window ).on( 'resize', swwapp.Display.signItems );

} );
